export default __webpack_public_path__ + "static/media/Avatar-3.b19ed2fa.svg";